import { useContext, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from 'utils/yup';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { UserRegisterRepository } from 'interfaceAdapter/repositories/UserRegister';
import { AgentUserTokenRepository } from 'interfaceAdapter/repositories/AgentUserToken';
import { useParams } from 'react-router-dom';
import { useLoading } from 'application/contexts/useLoading';

const schema = yup
    .object({
        password: yup
            .string()
            .required()
            .min(8)
            .max(100)
            .matches(
                /^(?=.*?[a-z])(?=.*?\d)[a-z\d!@#$%^&*()_+{}":?><,./;'[\]\\\-]{8,100}$/i,
                '半角英数字を含めて入力してください',
            ),
    })
    .required();

type PasswordForm = yup.InferType<typeof schema>;

export const useAgentPasswordRegistration = () => {
    const diContainer = useContext(diContainerContext);
    const userRegisterRepository = diContainer.resolve(UserRegisterRepository);
    const agentUserTokenRepository = diContainer.resolve(AgentUserTokenRepository);
    const { loading, setLoading } = useLoading();
    const [complete, setComplete] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [urlId, setUrlId] = useState('');
    const params = useParams();

    const {
        control,
        handleSubmit,
        formState: { errors },
        getValues,
    } = useForm<PasswordForm>({
        resolver: yupResolver(schema),
        mode: 'onChange',
        defaultValues: {
            password: '',
        },
    });

    useEffect(() => {
        if (!params.url_id) {
            return;
        }
        setUrlId(params.url_id);
    }, [params.url_id]);

    const send = handleSubmit(async ({ password }) => {
        setLoading(true);
        try {
            const data = await userRegisterRepository.agentRegistrationPassword(urlId, password);
            agentUserTokenRepository.set(data.session_token);
            setComplete(true);
            setShowSnackbar(true);
            // あまりいい方法ではないけれど。
            const fromInvite = window.location.href.includes('from_invite');
            if (fromInvite) {
                setTimeout(() => window.location.replace(`/agent/registration/user_profile/`), 1500);
                return;
            }
            setTimeout(() => window.location.replace(`/agent/registration/agent_profile/`), 1500);
        } finally {
            setLoading(false);
        }
    });

    return {
        control,
        errors,
        loading,
        complete,
        showSnackbar,
        setShowSnackbar,
        send,
        getValues,
    };
};
